/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?exposes=Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';
import Cookies from 'js-cookie'

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';
import './components/block-cart';
import $ from 'jquery';

import 'slick-carousel/slick/slick.js';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(function () {
    const dropDownEl = $('.js-dropdown');
    const form = new Form();
    const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
    const dropDown = new DropDown(dropDownEl);
    const topMenu = new TopMenu(topMenuEl);
    const productMinitature = new ProductMinitature();
    const productSelect = new ProductSelect();
    dropDown.init();
    form.init();
    topMenu.init();
    productMinitature.init();
    productSelect.init();

    $('.carousel[data-touch="true"]').swipe({
        swipe(event, direction) {
            if (direction === 'left') {
                $(this).carousel('next');
            }
            if (direction === 'right') {
                $(this).carousel('prev');
            }
        },
        allowPageScroll: 'vertical',
    });
    $('#home-page-tabs li:first, #index .tab-content .tab-pane:first').addClass('active in');

    $('.slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
                arrows: false
            }
        },

        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                dots: true,
                arrows: false

            }
        },
        ]
    });





    $('.similars-products').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.products-foryou').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });


    $('#home-page-tabs .nav-item').on('click', function () {
        setTimeout(function () {
            $('.slick-slider').slick('refresh');
        }, 200);
    });

    $('body').on('click', '#search_filters', function (event) {
        $("#content-wrapper #search_filters .facet").removeClass('open');
    });
    $('body').on('click', '#search_filters .facet-title', function (event) {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().toggleClass('open');
        } else {
            $("#content-wrapper #search_filters .facet").removeClass('open');
            $(this).parent().toggleClass("open");
        }
        event.preventDefault();
        return false;
    });

    var cook = Cookies.get('modalpop');
    if (cook != 'closed') {
        $('.modal_pop').addClass('open');
    }

    $('.bt_modal_pop.pro').on('click', function (event) {
        event.preventDefault();
        Cookies.set('modalpop', 'closed');
        location.href = $(this).attr('href');
        return false;
    });
    $('.bt_modal_pop.particulier').on('click', function (event) {
        event.preventDefault();
        Cookies.set('modalpop', 'closed');
        $('.modal_pop').removeClass('open');
        return false;
    });


    $('body').on('click', '#bt_filters', function (event) {
        $('#search_filters').toggleClass('close_filter');
        event.preventDefault();
        return false;
    });
    $('body').on('click', '.bloc_bt_all a', function (event) {
        if (document.location.href.indexOf('resultsPerPage') !== -1) {
        } else if (document.location.href.indexOf('?') === -1) {
            window.location.search += '&resultsPerPage=' + jQuery(this).data('total_items');
        } else {
            window.location.search += '?resultsPerPage=' + jQuery(this).data('total_items');
        }
        event.preventDefault();
        return false;
    });

});
